<template>
  <div class="recruit-canvas">
    <div class="canvas-box" ref="canvasRef">
      <div class="canvas-bg">
        <!-- 生成姓名提示词 -->
        <canvas ref="canvasTip" id="canvas-tip" width="100" height="100" />
      </div>
      <canvas ref="canvasMapRef" id="canvas-map" width="100" height="100" />
    </div>

    <slot name="default" :signatrue="canvasNode">
      <div class="btn-box flex-row">
        <span class="del-btn" @click="clearHandle">清除</span>
        <span class="sure-btn" @click="confirmHandle">确认</span>
        <div class="tips">请用正楷在虚线范围内签署姓名</div>
      </div>
    </slot>
  </div>
</template>

<script>
// import { uploadFile } from '@/service/upload'
import SignaturePad from 'signature_pad'
import { rotateBase64Img } from '@/utils/common'
import { submitForm, verifySignature } from '@/service/insurance'
export default {
  name: 'signatureH5',
  props: {
    options: Object
  },
  data() {
    return {
      canvasNode: '',
      name: '',
      screenHW: window.orientation, // 判断横竖屏
      isScreen: true, // 横竖屏
      form: {}
    }
  },
  mounted() {
    this.screenHW = window.orientation //保证刷新时获取状态准确
    // 监听窗口大小
    window.onresize = () => {
      return (() => {
        this.screenHW = window.orientation // 把横竖屏的变化赋值
      })()
    }
    if (sessionStorage.getItem('form')) {
      this.form = JSON.parse(sessionStorage.getItem('form'))
      this.name = this.form.userName
    }
  },
  watch: {
    screenHW: {
      immediate: true,
      handler() {
        this.rotate()
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.initalHandle()
      this.draw(this.name)
      window.addEventListener('resize', this.initalHandle, false)
    })
  },
  methods: {
    // 判断横竖屏
    rotate() {
      if (this.screenHW == 180 || this.screenHW == 0) {
        this.isScreen = true
      } else if (this.screenHW == 90 || this.screenHW == -90) {
        this.isScreen = false
      }
    },
    // 生成姓名提示词
    draw(name) {
      const _canvas = this.$refs.canvasTip
      const _canvasBox = this.$refs.canvasRef
      _canvas.width = _canvasBox.clientWidth
      _canvas.height = _canvasBox.clientHeight
      //获取canvs上下文
      var ctx = _canvas.getContext('2d')
      // 清除画布
      // ctx.setTransform(1, 0, 0, 1, 0, 0)
      ctx.clearRect(0, 0, _canvas.width, _canvas.height)
      //设置填充文字样式
      ctx.font = '170px Georgia'
      ctx.penColor = '#999'
      //设置文字及其位置
      ctx.fillStyle = 'rgb(200,200,200, 0.5)'
      // 竖屏
      if (this.isScreen) {
        ctx.translate(_canvas.width / 2, _canvas.height / 2)
        ctx.rotate(Math.PI / 2)
        ctx.fillText(name, -250, 60)
      } else {
        ctx.translate(_canvas.width / 2, _canvas.height / 2)
        ctx.fillText(name, -250, 50)
      }
    },
    initalHandle() {
      const _canvasBox = this.$refs.canvasRef
      const _canvas = this.$refs.canvasMapRef
      if (!_canvasBox || !_canvas) {
        console.warn('DOM节点初始化失败')
        return false
      }

      _canvas.width = _canvasBox.clientWidth
      _canvas.height = _canvasBox.clientHeight
      const computedOpt = Object.assign(
        {},
        {
          minWidth: 2,
          maxWidth: 2,
          penColor: 'rgb(0, 0, 0)'
        },
        this.options
      )

      this.clearHandle()
      this.canvasNode = new SignaturePad(_canvas, computedOpt)
      this.draw(this.name)
    },

    clearHandle() {
      const hasNode = this.canvasNode
      if (hasNode) {
        hasNode.clear()
        this.$emit('cancelEvent', hasNode)
      }
    },

    confirmHandle() {
      let _this = this
      // 重新初始化画布
      const canvasNode = this.canvasNode
      if (!canvasNode) {
        this.initalHandle()
      }

      // 是否签字
      if (canvasNode.isEmpty()) {
        this.$toast('您还没有签名')
        console.log(canvasNode, 'canvasNode')
        this.$emit('confirmEvent', canvasNode)
        return false
      }

      // 图像旋转二次处理
      const _boxWidth = window.innerWidth
      const _boxHeight = window.innerHeight
      const _signImg = canvasNode.toDataURL('image/png', 0.6) || null
      if (_boxWidth < _boxHeight) {
        rotateBase64Img(_signImg, -90, (imgUrlRes) => {
          // this.$emit('confirmEvent', imgUrlRes)
          console.log(imgUrlRes, 'imgUrlRes')
          // _signImg base64图片
          let file = _this.dataURLtoBlob(imgUrlRes)
          file.name = Date.now() + '.png'
          // blob转file
          let fileCompressed = _this.blobToFile(file, file.name)
          this.uploadFinalFile(fileCompressed)
        })
      } else {
        console.log(_signImg, '_signImg')
        // this.$emit('confirmEvent', _signImg)
        // _signImg base64图片
        let file = _this.dataURLtoBlob(_signImg)
        file.name = Date.now() + '.png'
        // blob转file
        let fileCompressed = _this.blobToFile(file, file.name)
        this.uploadFinalFile(fileCompressed)
      }
    },
    uploadFinalFile(file) {
      let formData = new FormData()
      formData.append('file', file, file.name)
      verifySignature(formData)
        .then((res) => {
          console.log(res.data, 'res.data')
          // 验证名字
          if (res.data.userSignature && res.data.userSignature == this.name) {
            this.form.signaturePhoto = res.data.sysOssUploadVo.url
            // 提交表单
            submitForm(this.form)
              .then(() => {
                this.$toast.success('提交成功')
                sessionStorage.removeItem('form')
                setTimeout(() => {
                  this.$router.replace('/finished')
                })
              })
              .catch((err) => {
                this.$toast.fail(err)
              })
          } else {
            this.$toast.fail('请规范填写正确的姓名')
          }
        })
        .catch(() => {})
    },
    //将base64转换为blob
    dataURLtoBlob(dataurl) {
      console.log(dataurl, 'dataurl')
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    //将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.initalHandle, false)
    }
  }
}
</script>

<style lang="stylus" scoped>
*{
  -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
  -webkit-user-select:none; /*webkit浏览器*/
  -khtml-user-select:none; /*早期浏览器*/
  -moz-user-select:none;/*火狐*/
  -ms-user-select:none; /*IE10*/
  user-select:none;
}
.recruit-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.recruit-canvas .preview-image {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 999;
  transform: translate(-50%, -50%);
}
// .recruit-canvas .btn-box {
//   left: -22%;
//   z-index: 1000;
//   text-align: center;
//   transform: rotate(90deg);
//   -o-transform: rotate(90deg);
//   -ms-transform: rotate(90deg);
//   -moz-transform: rotate(90deg);
//   -webkit-transform: rotate(90deg);
// }

.recruit-canvas .canvas-box,
.recruit-canvas .btn-box {
  position: absolute;
  top: 50%;
  z-index: 100;
}
.recruit-canvas .btn-box {
  left: -22%;
  z-index: 1000;
  text-align: center;
  transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}
.recruit-canvas .btn-box .del-btn,
.recruit-canvas .btn-box .sure-btn {
  display: inline-block;
  width: 100px;
  height: 24px;
  margin: 0 10px;
  line-height: 24px;
  border-radius: 6px;
  background-color: #fff;
}
.recruit-canvas .btn-box .del-btn {
  color: #E99D42;
}
.recruit-canvas .btn-box .sure-btn {
  color: #fff;
  background: #E99D42
}
.recruit-canvas .btn-box .tips{
  margin-top: 10px
  font-size: 20px
}
.recruit-canvas .canvas-box {
  left: 22%;
  height: 80vh;
  width: 70vw;
  overflow: hidden;
  border: 1px dashed #D4D4D4;
  transform: translateY(-50%);
  background-color: #fff;
}
.recruit-canvas .canvas-box .canvas-bg {
  z-index -1
  position: absolute
}
.recruit-canvas .canvas-box #canvas-map {
  width: 100%;
  height: 100%;
}
.recruit-canvas .canvas-box #canvas-tip {
  width: 100%;
  height: 100%;
}
@media screen and (orientation: portrait) {
  /*竖屏 css*/
  .recruit-canvas .canvas-box {
    top: 10vh;
    left: 15%;
    width: 80vw;
    height: 80vh;
    transform: translateY(0);
  }
  .recruit-canvas .btn-box {
    width: 60%;
    top: 20vh;
    padding-top: 20px;
  }
  .recruit-canvas .btn-box .del-btn,
  .recruit-canvas .btn-box .sure-btn {
    height: 40px
    line-height: 40px
  }
}
@media screen and (orientation: landscape) {
  /*横屏 css*/
  .recruit-canvas .canvas-box {
    top: 20px;
    left: 10%;
    width: 80vw;
    height: 70vh;
    transform: translateY(0);
  }
  .recruit-canvas .btn-box {
    width: 60%;
    left: 20%;
    top: 80%;
    transform: rotate(0);
  }
  .recruit-canvas .btn-box .tips{
    font-size: 16px
    color: #9a9a9a
    display: absolute
  }
}
</style>
